import {createAction, props} from "@ngrx/store";
import {LocalStorageSyncAutoRegType} from "@/shared/types/LocalStorageSync.type";

export const autoRegLoadFromLocalStorage = createAction(
  '[Auto-reg] Load state',
  props<{value: LocalStorageSyncAutoRegType}>()
)
